import React, { FC, SVGAttributes } from "react"
import SVG from "../svg"

const Fire: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <SVG
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fillRule="evenodd"
                d="M352.258 395.394c6.326-23.131-5.953-70.684-5.953-70.684s-8.906 38.739-22.822 53.057c-11.872 12.213-26.417 20.684-47.277 22.91 17.055-8.284 28.784-25.557 28.784-45.522 0-28.026-23.112-50.746-51.622-50.746s-51.623 22.72-51.623 50.746a49.84 49.84 0 004.812 21.421c-17.832-14.206-20.636-36.982-20.636-36.982s-19.912 82.67 34.954 121.558c54.865 38.888 162.344 5.462 162.344 5.462S229.41 574.837 115.436 457.05c-98.18-101.466-25.625-235.047-25.625-235.047s-3.133 12.392-3.133 26.777c0 14.385 7.799 25.33 7.799 25.33s23.265-49.039 41.371-68.982c17.136-18.874 38.617-34.182 57.171-47.404 14.282-10.178 26.83-19.12 34.324-27.501C268.62 84.069 243.311 0 243.311 0s46.53 41.02 59.52 93.998c4.952 20.194 1.766 43.171-1.082 63.718-4.624 33.356-8.361 60.309 25.044 58.56 53.982-2.827 7.073-86.053 7.073-86.053s122.452 64.36 113.304 176.922c-9.149 112.562-133.846 138.152-133.846 138.152s32.607-26.772 38.934-49.903z"
                clipRule="evenodd"
            ></path>
        </SVG>
    )
}

export default Fire
